import Schema from 'AppReact/schema';
import { badge } from '../../../../../../types';

export default {
  badge: Schema(badge, 'object', { defaultValue: { name: '', image: '', description: '' } }),
  isTemplate: Schema('boolean', 'primitive', { defaultValue: false }),
  preview: Schema('boolean', 'primitive', { defaultValue: false }),
  icons: Schema({}, 'object', { defaultValue: {} })
}